import { Button } from "@/components/ui/Button";
import { useToast } from "@/components/feedback/toast-context";
import type { MediaItem } from "@/features/media/types";
import { ImagePreview } from "./ImagePreview";

interface MediaCardProps {
  item: MediaItem;
  selected?: boolean;
  canDelete?: boolean;
  onSelect?: (item: MediaItem) => void;
  onEdit?: (item: MediaItem) => void;
  onDelete?: (item: MediaItem) => void;
}

export function MediaCard({ item, selected, canDelete, onSelect, onEdit, onDelete }: MediaCardProps) {
  const toast = useToast();

  async function copyUrl() {
    try {
      await navigator.clipboard.writeText(item.url);
      toast.success("Image URL copied.");
    } catch {
      toast.error("Unable to copy image URL.");
    }
  }

  return (
    <article className={selected ? "rounded-md border border-cyan-300 bg-cyan-300/10 p-3 shadow-neon" : "rounded-md border border-cyan-300/15 bg-black/30 p-3"}>
      <button type="button" className="block w-full text-left" onClick={() => onSelect?.(item)} aria-label={`Select ${item.originalName}`}>
        <ImagePreview item={item} />
        <p className="mt-3 truncate text-sm font-medium text-white">{item.originalName}</p>
        <p className="mt-1 text-xs text-content-muted">{Math.round(item.size / 1024)} KB</p>
      </button>
      <div className="mt-3 flex flex-wrap gap-2">
        <Button size="sm" variant="ghost" onClick={copyUrl}>
          Copy URL
        </Button>
        {onEdit && <Button size="sm" variant="secondary" onClick={() => onEdit(item)}>Edit</Button>}
        {canDelete && onDelete && <Button size="sm" variant="danger" onClick={() => onDelete(item)}>Delete</Button>}
      </div>
    </article>
  );
}
